/*
 * Copyright (c) Hilo 2020.
 * Author: fharold
 *
 * hilo-oauth-manager
 * AddExportModal.tsx
 */

import React from "react";
import Modal, {ModalProps, ModalState} from "./Modal";
import NavigationService, {NavigationListener} from "../../service/NavigationService";
import {Page} from "../../model/pagination/Page";

interface Props extends ModalProps {
}

interface State extends ModalState {
    currentPage?: Page
}

export default class PageSelectorModal extends Modal<Props, State> implements NavigationListener {
    public state: State;
    private readonly _navigationService : NavigationService;

    /**
     * constructor
     * @param props
     * @param state
     */
    constructor(props: Props, state: State) {
        super(props, state);

        this._navigationService = this._serviceRepository.resolve(NavigationService.id) as NavigationService;

        this.state = {
            loading: false,
            currentPage: this._navigationService.currentPage
        };
    }

    /**
     * componentDidMount
     */
    public componentDidMount() {
        super.componentDidMount();
        this._navigationService.addListener(this);
    }


    /**
     * componentWillUnmount
     */
    public componentWillUnmount() {
        super.componentWillUnmount();
        this._navigationService.removeListener(this);
    }

    /**
     * onSave
     */
    public onSave = undefined;

    private _page = (props: { page: Page }) => {
        const {currentPage} = this.state;
        const isCurrentPage = currentPage && this._navigationService.isGivenPageTheCurrentPage(props.page)

        return <div className={`page-item-small`} onClick={() => {
            this._navigationService.load(props.page.paths[0]);
            this.dismiss()
        }}>
            <img src={props.page.icon} alt={"icon"}/>
            <p className={`${isCurrentPage ? "selected" : "not-selected"}`}>{props.page.titleAccessor(this.t)}</p>
        </div>
    }

    /**
     * historyHasBeenUpdated
     */
    historyHasBeenUpdated(): void {
        this.setState({
            currentPage: this._navigationService.currentPage
        })
    }

    /**
     * renderBody
     */
    public renderBody(): JSX.Element {
        return <div className={"page-selector-modal"}>
            {
                NavigationService.pages.map(page => <this._page key={page.paths[0]} page={page}/>)
            }
        </div>
    }
}